export default __webpack_public_path__ + "static/media/test.97e44f49.svg";